/* Alertes du tableau de bord des projets que l'on coche « vues » (arbitrage du 15/10/2026). */

/** Alerte cochable : `kind` la distingue sur sa phase, `scope` dit ce qu'elle concerne (année de
    contrat d'un quota, jours vendus d'un forfait, date de fin d'une phase). */
export interface DashboardAlert {
  kind: string;
  level: 'alert' | 'warn';
  scope: string;
}

/** Bandeau en tête d'une carte projet. */
export interface Ribbon extends DashboardAlert {
  text: string;
}

export type SeenAlert = Pick<DashboardAlert, 'level' | 'scope'>;
export type SeenAlerts = Record<string, SeenAlert>;

const RANK: Record<DashboardAlert['level'], number> = { warn: 1, alert: 2 };

// Une alerte cochée reste masquée tant qu'elle ne s'aggrave pas (consommation rapide → quota
// dépassé) et que ce qu'elle concerne ne change pas (nouvelle année de contrat, jours vendus
// modifiés, date de fin déplacée) ; sinon elle revient. La coche est partagée entre managers.
export function isAlertSeen(alert: DashboardAlert, seen: SeenAlerts | null | undefined): boolean {
  const s = seen?.[alert.kind];
  return !!s && s.scope === alert.scope && RANK[s.level] >= RANK[alert.level];
}

// Coches de la phase après avoir coché cette alerte.
export function withAlertSeen(
  seen: SeenAlerts | null | undefined,
  alert: DashboardAlert,
): SeenAlerts {
  return { ...(seen || {}), [alert.kind]: { level: alert.level, scope: alert.scope } };
}
